import * as angular from 'angular';
import * as _ from 'lodash';
import JsonApiParser from '../services/jsonapi-parser';

class BackendService {
  private config = { headers: { 'Content-Type': 'application/vnd.api+json' } };

  private clientName = 'epx';

  constructor(
    private $http: any,
    private $q: any,
    private apiUrl: string,
    private parser: JsonApiParser
  ) {
    $http.defaults.headers.common.Accept = 'application/vnd.api+json';
  }

  getAll = (type, query) => {
    let url: string = this.apiUrl + type;
    if (query) {
      url = this.filterizeUrl(url, query);
    }

    let deferred = this.$q.defer();

    url = this.watermarkUrl(url);

    return this.$http
      .get(url, { timeout: deferred.promise, cancel: deferred })
      .then(response => (response ? this.parser.parse(response.data) : []));
  };

  get(type, id, query) {
    let url: string = `${this.apiUrl}${type}/${id}`;
    if (query) {
      url = this.filterizeUrl(url, query);
    }

    let deferred = this.$q.defer();

    url = this.watermarkUrl(url);

    return this.$http
      .get(url, { timeout: deferred.promise, cancel: deferred })
      .then(response => (response ? this.parser.parse(response.data) : {}));
  }

  create(type, model) {
    const payload = {
      data: {
        type: type,
        attributes: model.attributes,
        relationships: model.relationships
      }
    };

    return this.$http
      .post(`${this.apiUrl}${type}`, payload, this.config)
      .then(response => this.parser.parse(response.data));
  }

  delete(type, model) {
    return this.$http
      .delete(`${this.apiUrl}${type}/${model.id}`)
      .then(response => (response.status === 204 ? true : response.data));
  }

  update(type, model) {
    const payload = {
      data: {
        id: model.id,
        type: type,
        attributes: model.attributes,
        relationships: model.relationships
      }
    };
    const url: string = `${this.apiUrl}${type}/${model.id}`;

    return this.$http
      .patch(url, payload, this.config)
      .then(response => this.parser.parse(response.data));
  }

  private filterizeUrl(url, filter) {
    const filterString: string = _.chain(filter)
      .map((value, key) => {
        switch (key) {
          case 'include':
          case 'sort':
            return `${key}=${value}`;
          case 'page':
            return `page[number]=${value}`;
          case 'fields':
            return _.chain(value).map((v, k) => `fields[${k}]=${v}`).join('&').value();
          default:
            return `filter[${key}]=${value}`;
        }
      })
      .join('&')
      .value();

    if (filterString.length) {
      return `${url}?${filterString}`;
    } else {
      return url;
    }
  }

  private watermarkUrl(url) {
    let hasQuery = url.includes('?');
    if (hasQuery) {
      url = url + '&';
    } else {
      url = url + '?';
    }

    return url + 'client=' + this.clientName;
  }
}

angular
  .module('ciApp.services')
  .service('BackendService', ['$http', '$q', 'apiUrl', 'JsonApiParser', BackendService]);



// WEBPACK FOOTER //
// ./common/services/backend.service.ts